module.exports = __webpack_public_path__ + "static/media/carta_54.b3d47f30.jpg";